import { CustomerPlanBase } from '../json-schemas/base/customer_plan'
import { CustomerPlanSubscriptionBase } from '../json-schemas/base/customer_plan_subscription'
import { OfferedServiceBase } from '../json-schemas/base/offered_service'
import { CustomerPlanSubscriptionNewResponse } from '../json-schemas/serializers/customer-plan-subscription-new-response'
import { CustomerPlanSubscriptionShowResponse } from '../json-schemas/serializers/customer-plan-subscription-show-response'
import { CustomerPlanSubscriptionsListCountPerScopeResponse } from '../json-schemas/serializers/customer-plan-subscriptions-list-count-per-scope-response'
import { CustomerPlanSubscriptionsListResponse } from '../json-schemas/serializers/customer-plan-subscriptions-list-response'
import { httpGet, httpGetRoute, httpPatch, httpPost } from '../utils/http.service'
import { I18nService } from '../utils/i18n.service'

export interface RansackQuery {
  scope?: 'paid_not_expired' | 'unpaid_not_expired' | 'expired' | 'all'
  'q[id_not_in][]'?: number[]
  'q[customer_id_eq]'?: number
  'q[customer_sortable_name_or_customer_reversed_sortable_name_cont]'?: string
  'q[customer_plan_id_eq]'?: CustomerPlanBase['id'],
  'q[customer_plan_validity_duration_in_months_eq]'?: number
  'q[customer_plan_quantity_frequency_eq]'?: CustomerPlanBase['quantity_frequency']
  'q[where_offered_service_ids]'?: OfferedServiceBase['id'] | OfferedServiceBase['id'][]
}

export const customerPlanSubscriptionScopes : RansackQuery['scope'][] = ['paid_not_expired', 'unpaid_not_expired', 'expired']

const i18nScoped = new I18nService(require('./customer-plan-subscriptions.service.yml'))

export function customerPlanSubscriptionsIndex (query: RansackQuery = {}): Promise<CustomerPlanSubscriptionsListResponse> {
  return httpGet(`/${httpGetRoute()}/customer_plan_subscriptions`, query)
}

export function customerPlanSubscriptionsCountPerScope (query: RansackQuery = {}): Promise<CustomerPlanSubscriptionsListCountPerScopeResponse> {
  return httpGet(`/${httpGetRoute()}/customer_plan_subscriptions/count_per_scope`, query)
}

export function customerPlanSubscriptionNew (params?: { customer_id?: number }): Promise<CustomerPlanSubscriptionNewResponse> {
  return httpGet(`/${httpGetRoute()}/customer_plan_subscriptions/new`, params)
}

export function customerPlanSubscriptionCreate (body: any): Promise<{ redirect_url: string }> {
  return httpPost(`/${httpGetRoute()}/customer_plan_subscriptions`, { customer_plan_subscription: body })
}

export function customerPlanSubscriptionShow (id: CustomerPlanSubscriptionBase['id']): Promise<CustomerPlanSubscriptionShowResponse> {
  return httpGet(`/${httpGetRoute()}/customer_plan_subscriptions/${id}`)
}

export function customerPlanSubscriptionTerminate (id: CustomerPlanSubscriptionBase['id'], end_date: string) {
  return httpPatch(`/${httpGetRoute()}/customer_plan_subscriptions/${id}/terminate`, { end_date })
}

export function customerPlanSubscriptionUpdateExpirationAction (id: CustomerPlanSubscriptionBase['id'], expiration_action: CustomerPlanSubscriptionBase['expiration_action']) {
  return httpPatch(`/${httpGetRoute()}/customer_plan_subscriptions/${id}/update_expiration_action`, { customer_plan_subscription: { expiration_action } })
}

export function customerPlanSubscriptionI18nScope (scope: RansackQuery['scope']) {
  return i18nScoped.t(`scope.${scope}`)
}
